import React from "react";

import {About, ContactUsLink, CurrentUserAvatar, HomeLink, LogOut, OtherResources} from "@digatex/digatex-ui-lib";
import {Layout, Space, Typography} from "antd";

import {CurrentUserContext} from "../../contexts/AuthContext.js";
import {APP_INSTANCE, properties} from "../../properties";

class DHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			triedToSubmit: false,
			submitInProgress: false,
			project: {},
		};

		this.formRef = React.createRef();
	}

	static contextType = CurrentUserContext;

	componentDidMount() {
		const observer = new MutationObserver(() => {
			const iframe = document.querySelector("#jsd-widget");
			if (iframe && iframe.contentDocument) {
				observer.disconnect();

				this.hideHelpButton(iframe);

				const iframeObserver = new MutationObserver(() => {
					this.hideHelpButton(iframe);
				});
				iframeObserver.observe(iframe.contentDocument.body, {childList: true, subtree: true});
			}
		});

		observer.observe(document.body, {childList: true, subtree: true});
	}

	hideHelpButton = iframe => {
		const helpButton = iframe.contentDocument?.querySelector("#help-button");

		iframe.style.bottom = helpButton ? `-${iframe.style.height}` : "0px";
	};

	showRequestForm = () => {
		const iframeContent = document.querySelector("#jsd-widget")?.contentDocument;

		const button = iframeContent?.querySelector("#help-button");

		if (button) {
			button.click();

			const observer = new MutationObserver((mutationsList, observer) => {
				const helpForm = iframeContent.querySelector(".help-form");
				if (helpForm) {
					observer.disconnect();

					const inputData = [
						{class: "#email", value: this.context.email()},
						{class: "#customfield_10051", value: APP_INSTANCE},
						{class: "#customfield_10053", value: "Landing Page"},
					];

					inputData.forEach(selector => {
						const input = iframeContent.querySelector(selector.class);
						if (input) {
							input.setAttribute("value", selector.value);
							input.dispatchEvent(new Event("change", {bubbles: true}));
						} else {
							console.log(`Input ${selector.class} not found!`);
						}
					});
				}
			});

			observer.observe(iframeContent.body, {childList: true, subtree: true});
		}
	};

	render() {
		return (
			<div>
				<Layout.Header
					style={{padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
					<HomeLink title={<div style={{width: 50}}></div>} />
					<Typography.Title
						level={3}
						style={{color: "white", paddingLeft: 32, paddingTop: 7.25, marginLeft: "auto"}}>
						{properties.landingHeaderName}
					</Typography.Title>

					<div style={{marginLeft: "auto"}}>
						<Space size={"middle"}>
							<About />
							<OtherResources />
							<ContactUsLink show={this.showRequestForm} />
							<LogOut />
							<CurrentUserAvatar />
						</Space>
					</div>
				</Layout.Header>
			</div>
		);
	}
}

export const Header = DHeader;
